import { z } from 'zod';

/** Where the workshop asks to deliver a customer notice (app push or WhatsApp). */
export const CUSTOMER_DELIVERY_CHANNELS = ['APP', 'WHATSAPP'] as const;

export const CustomerDeliveryChannelSchema = z.enum(CUSTOMER_DELIVERY_CHANNELS);

export type CustomerDeliveryChannel = z.infer<typeof CustomerDeliveryChannelSchema>;
